import React from 'react';
import {Spin} from 'antd';
import {WeaTools} from 'ecCom';
import EHeader from '../common/EHeader';
import {NoRightCom} from '../../util/common';

// 自定义元素
class CustomElement extends React.Component {
    state = {loading: false, deleted: false};

    constructor(props) {
        super(props);
        this.handleRefresh = this.handleRefresh.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
    }

    componentWillMount() {
        const {config = {}} = this.props;
        const {item = {}} = config;
        const {custom = {}} = item;
        const {modulename, packagename} = custom;

        if (modulename && !window[packagename]) {
            this.setState({loading: true});
            WeaTools.loadDevModules(modulename, packagename).then(() => {
                const _interval = window.setInterval(() => {
                    if (window[packagename]) {
                        this.setState({loading: false});
                        window.clearInterval(_interval);
                    }
                }, 100);
            });
        }
    }

    render() {
        const {loading, deleted} = this.state;

        // 元素已删除，返回空
        if (deleted) return <div/>;

        const {config, fontSizeMp} = this.props;
        const {isHasRight, isSetting, item, params, synergyParams} = config;
        const {eid, ebaseid, style, contentview, custom = {}} = item;
        const {style: style1= {}} = contentview;
        let   {packagename, viewcompname, moreurl} = custom;

        try {
            if (moreurl) {
                if (config.item.header && config.item.header.toolbar && config.item.header.toolbar.more) {
                    if (moreurl.indexOf('?')!=-1) {
                        moreurl += '&eid='+eid;
                    } else {
                        moreurl += '?eid='+eid;
                    }
                    config.item.header.toolbar.more.morehref = moreurl;
                }
            } else {
                config.item.header.toolbar.more = null;
            }
        } catch (e) {
        }

        let EContent = null;
        if (isHasRight) {
            if (!loading) {
              if(window.rewritePortalCusEle && typeof rewritePortalCusEle == 'function') {
                const props = {...this.props};
                const options = {
                  config,
                  fontSizeMp,
                  isSetting,
                  id:eid,
                  eid,
                  ebaseid,
                  params,
                  synergyParams
                }
                EContent = window.rewritePortalCusEle(props, options);
              }
              if (EContent == null && window[packagename] && window[packagename]['com'] && window[packagename]['com'][viewcompname]) {
                const EContentTemp = window[packagename]['com'][viewcompname];
                EContent = <EContentTemp {...this.props} config={config} fontSizeMp={fontSizeMp} isSetting={isSetting} id={eid} eid={eid} params={params} synergyParams={synergyParams}/>;
              }
            } else {
                EContent = <div style={{width: '100%', height: '60px'}}/>;
            }
        } else {
            EContent = <NoRightCom/>;
        }

        return (
            <div className="item"
                style={style}
                id={`item_${eid}`} 
                data-eid={eid} data-ebaseid={ebaseid} 
                data-needRefresh={item.needRefresh} 
                data-cornerTop={item.cornerTop} 
                data-cornerTopRadian={item.cornerTopRadian}
                data-cornerBottom={item.cornerBottom} 
                data-cornerBottomRadian={item.cornerBottomRadian}>
                <EHeader config={config} handleRefresh={this.handleRefresh} handleDelete={this.handleDelete} fontSizeMp={fontSizeMp}/>
                <div className="setting" id={`setting_${eid}`}></div>
                <div className="content" id={`content_${eid}`} style={{width: 'auto', _width: '100%'}}>
                    <div className="content_view" id={`content_view_id_${eid}`} style={{height: style1.height}}>
                        <Spin spinning={loading}>{EContent}</Spin>
                    </div>
                    <div style={{textAlign: 'right'}} id={`footer_${eid}`}></div>
                </div>
            </div>
        );
    }

    handleRefresh() {
        this.setState({loading: true});
        setTimeout(() => this.setState({loading: false}), 100);
    }

    handleDelete() {
        this.setState({deleted: true});
    }
}

export default CustomElement






// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/customelement/index.js